export const BrandSurveyData = [
  { 'value': 'Search Engine (Google, Yahoo, etc)', 'label': 'Search Engine (Google, Yahoo, etc)' },
  { 'value': 'Facebook, Instagram Ad / Post', 'label': 'Facebook, Instagram Ad / Post' },
  { 'value': 'Twitter Ad / Post', 'label': 'Twitter Ad / Post' },
  { 'value': 'YouTube Ad / Post', 'label': 'YouTube Ad / Post' },
  { 'value': 'Brochure / Banner in Hospital', 'label': 'Brochure / Banner in Hospital' },
  { 'value': 'Recommended by Doctor', 'label': 'Recommended by Doctor' },
  { 'value': 'Recommended by Hospital Staff Member', 'label': 'Recommended by Hospital Staff Member' },
  { 'value': 'Recommended By Friend / Family member', 'label': 'Recommended By Friend / Family member' },
  { 'value': 'Ketto Representative', 'label': 'Ketto Representative' },
  { 'value': 'Recommended by NGO', 'label': 'Recommended by NGO' },
  { 'value': 'WhatsApp DM / Group', 'label': 'WhatsApp DM / Group' },
  { 'value': 'Influencer / Content Creator', 'label': 'Influencer / Content Creator' },
  { 'value': 'Newspaper / TV / Billboard', 'label': 'Newspaper / TV / Billboard' }
];
